import { call, put, select, takeLatest, fork } from 'redux-saga/effects';

import {
  FETCH_SCHOOLS_REQUEST,
  fetchSchoolsSuccess,
  fetchSchoolsFailure,
} from '../actions/fetchSchoolsActions';
import SchoolAPI from '../api/SchoolAPI';
import { accessTokenSelector } from '../reducers/selectors';

import { manageAPIError } from './helpers/errorHelper';

function* schoolsWatcher() {
  yield takeLatest(FETCH_SCHOOLS_REQUEST, schoolsWorker);
}

function* schoolsWorker(action) {
  try {
    const accessToken = yield select(accessTokenSelector);
    const payload = yield call(SchoolAPI.getSchools, accessToken);
    yield put(fetchSchoolsSuccess(payload));
  } catch (error) {
    yield put(fetchSchoolsFailure(error));
    yield fork(manageAPIError, { ...error, action, useFallbackError: false });
  }
}

export { schoolsWorker };
export default schoolsWatcher;
